// Ad network identifiers — ported from the reference games' ads/banner.js
// pattern (AdSense client/slot IDs, AdMob unit IDs). All blank until a real
// account/units are issued; every ad surface in src/gamzone/ads/ checks these
// and falls back to a "광고 영역" placeholder while they're empty, so wiring in
// the real IDs later is a one-line change with no other code to touch.

export const ADSENSE_CLIENT_ID = "";
export const ADSENSE_BANNER_SLOT_ID = "";
export const ADSENSE_INTERSTITIAL_SLOT_ID = "";
export const ADMOB_BANNER_UNIT_ID = "ca-app-pub-6107442886526708/2908732302";
export const ADMOB_INTERSTITIAL_UNIT_ID = "ca-app-pub-6107442886526708/7301246761";
// 일시정지/패배/무승부/승리 팝업에서 1분간 조작 없을 때 뜨는 전면광고 — 막 전환
// 게이트(ADMOB_INTERSTITIAL_UNIT_ID)와는 다른 광고 단위. See MatchScreen.tsx.
export const ADMOB_IDLE_INTERSTITIAL_UNIT_ID = "ca-app-pub-6107442886526708/6046031531";
export const ADMOB_REWARDED_UNIT_ID = "ca-app-pub-6107442886526708/2702069939";

export function isBannerAdConfigured(): boolean {
  return Boolean(ADSENSE_BANNER_SLOT_ID || ADMOB_BANNER_UNIT_ID);
}
export function isInterstitialAdConfigured(): boolean {
  return Boolean(ADSENSE_INTERSTITIAL_SLOT_ID || ADMOB_INTERSTITIAL_UNIT_ID);
}
export function isRewardedAdConfigured(): boolean {
  return Boolean(ADMOB_REWARDED_UNIT_ID);
}
